import { useState } from "react";
import Toast from "../Toast/Toast";
import "./Earlyexitmodal.scss";

const formatCurrency = (value) =>
  Number(value || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

export default function EarlyExitModal({
  jobTitle,
  jobPayment,
  mode = "normal",
  onConfirm,
  onClose,
}) {
  const isEarlyExit = mode === "early";

  const [reason, setReason] = useState("");
  const [editPayment, setEditPayment] = useState(false);
  const [paymentInput, setPaymentInput] = useState(
    Number(jobPayment || 0).toFixed(2)
  );
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ message: "", type: "success" });

  const showToast = (message, type = "success") => {
    setToast({ message, type });
  };

  const getAdjustedPayment = () =>
    Number(String(paymentInput).replace(",", "."));

  const handleConfirm = async () => {
    if (isEarlyExit && reason.trim().length < 10) {
      showToast(
        "Descreva o motivo da saída antecipada com pelo menos 10 caracteres.",
        "info"
      );
      return;
    }

    let freelancerPayment = null;

    if (isEarlyExit && editPayment) {
      freelancerPayment = getAdjustedPayment();

      if (
        Number.isNaN(freelancerPayment) ||
        freelancerPayment < 0 ||
        freelancerPayment > Number(jobPayment)
      ) {
        showToast(
          `Informe um valor entre R$ 0,00 e ${formatCurrency(jobPayment)}.`,
          "info"
        );
        return;
      }
    }

    setLoading(true);

    try {
      await onConfirm({
        finishedOnTime: !isEarlyExit,
        reason: isEarlyExit ? reason.trim() : null,
        freelancerPayment,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="eem-overlay" onClick={loading ? undefined : onClose}>
      <div
        className="eem-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="eem-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="eem-header">
          <h3 id="eem-title">
            {isEarlyExit ? "Encerrar turno antecipadamente" : "Finalizar vaga"}
          </h3>

          <button
            type="button"
            className="eem-close"
            onClick={onClose}
            disabled={loading}
            aria-label="Fechar"
          >
            ×
          </button>
        </div>

        <div className="eem-body">
          <div className="eem-question">
            <p>
              {isEarlyExit ? (
                <>
                  Registre o encerramento antecipado da vaga{" "}
                  <strong>{jobTitle}</strong>.
                </>
              ) : (
                <>
                  Confirma a finalização normal da vaga{" "}
                  <strong>{jobTitle}</strong>?
                </>
              )}
            </p>
          </div>

          {isEarlyExit ? (
            <>
              <div className="eem-field">
                <label>
                  Motivo do encerramento antecipado <span>*</span>
                </label>

                <textarea
                  value={reason}
                  onChange={(event) =>
                    setReason(event.target.value.substring(0, 300))
                  }
                  placeholder="Ex.: o freelancer precisou sair mais cedo devido a um imprevisto..."
                  rows={4}
                  maxLength={300}
                  disabled={loading}
                />

                <span className="eem-counter">{reason.length}/300</span>
              </div>

              <div className="eem-payment">
                <div className="eem-payment__header">
                  <div>
                    <strong>Pagamento ao freelancer</strong>
                    <small>
                      Valor original: {formatCurrency(jobPayment)}
                    </small>
                  </div>

                  <label className="eem-payment__toggle">
                    <input
                      type="checkbox"
                      checked={editPayment}
                      onChange={(event) => setEditPayment(event.target.checked)}
                      disabled={loading}
                    />
                    Editar valor
                  </label>
                </div>

                {editPayment ? (
                  <div className="eem-payment__input">
                    <label htmlFor="freelancer-payment">
                      Valor que o freelancer receberá
                    </label>

                    <div>
                      <span>R$</span>
                      <input
                        id="freelancer-payment"
                        type="number"
                        min="0"
                        max={jobPayment}
                        step="0.01"
                        value={paymentInput}
                        onChange={(event) => setPaymentInput(event.target.value)}
                        disabled={loading}
                      />
                    </div>
                  </div>
                ) : (
                  <p className="eem-payment__notice">
                    O freelancer receberá o valor integral da vaga.
                  </p>
                )}

                <p className="eem-payment__hint">
                  As taxas administrativa e de urgência permanecem destinadas à
                  plataforma.
                </p>
              </div>

              <p className="eem-notice">
                O motivo será registrado junto ao encerramento da vaga.
              </p>
            </>
          ) : (
            <p className="eem-notice eem-notice--success">
              ✓ O freelancer receberá {formatCurrency(jobPayment)} e o fluxo
              seguirá normalmente para transferência e avaliação.
            </p>
          )}
        </div>

        <div className="eem-footer">
          <button
            type="button"
            className="eem-btn eem-btn--cancel"
            onClick={onClose}
            disabled={loading}
          >
            Cancelar
          </button>

          <button
            type="button"
            className="eem-btn eem-btn--confirm"
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading
              ? "Finalizando..."
              : isEarlyExit
                ? "Confirmar encerramento"
                : "Confirmar finalização"}
          </button>
        </div>
      </div>

      <Toast
        message={toast.message}
        type={toast.type}
        onClose={() => setToast({ message: "", type: "success" })}
      />
    </div>
  );
}